import React from 'react';
import { Input } from 'ui-components';

export const Email: React.FC = () => {
  return (
    <div className="space-y-2">
      <Input
        name="email"
        type="email"
        label="Contact email"
        placeholder="Enter email address"
        track-id="foam-profile-settings--email-input"
        isRequired
        clearButtonProps={{
          'aria-label': 'Clear email',
          trackId: 'foam-profile-settings--email-clear',
        }}
      />
      <p className="px-3 text-14 text-form-base-helper-color">
        Used for your contact button. Can be different from your Foam login.
      </p>
    </div>
  );
};
